var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.33331C11.7275 5.33331 12.7449 5.75474 13.4951 6.50489C14.2452 7.25503 14.6667 8.27245 14.6667 9.33331V14H12V9.33331C12 8.97969 11.8595 8.64055 11.6095 8.3905C11.3594 8.14046 11.0203 7.99998 10.6667 7.99998C10.313 7.99998 9.9739 8.14046 9.72385 8.3905C9.4738 8.64055 9.33333 8.97969 9.33333 9.33331V14H6.66666V9.33331C6.66666 8.27245 7.08809 7.25503 7.83823 6.50489C8.58838 5.75474 9.6058 5.33331 10.6667 5.33331Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 5.99998H1.33333V14H3.99999V5.99998Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 3.99998C3.40304 3.99998 3.99999 3.40303 3.99999 2.66665C3.99999 1.93027 3.40304 1.33331 2.66666 1.33331C1.93028 1.33331 1.33333 1.93027 1.33333 2.66665C1.33333 3.40303 1.93028 3.99998 2.66666 3.99998Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.e750437f4feb977ee7ff840a249470f6.svg";
export { ForwardRef as ReactComponent };